import { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router'
import useRouter from 'utils/useRouter'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'

export const useExameConstatacao = () => {
  const params = useParams()
  const router = useRouter()
  const exameRealizadoService = useExameRealizadoService()

  const [exameRealizado, setExameRealizado] = useState(null)
  const [activeStep, setActiveStep] = useState(0)
  const [respostasQuesitos, setRespostasQuesitos] = useState(null)
  const [processandoAlteracaoRespostas, setProcessandoAlteracaoRespostas] = useState(false)

  const fetchExameRealizado = useCallback(async () => {
    if (params.idExameRealizado) {
      try {
        const response = await exameRealizadoService.listarExameRealizadoDetalhadoAsync(
          params.idExameRealizado
        )
        setExameRealizado(response || null)
      } catch (error) {
        console.error('Error fetching exame realizado:', error)
      }
    }
  }, [params.idExameRealizado]) // Excluded service dependency to prevent loops

  const handleEtapaAnterior = useCallback(() => {
    if (activeStep === 0) return
    setActiveStep((prevStep) => prevStep - 1)
  }, [activeStep])

  const handleProximaEtapa = useCallback(async () => {
    if (activeStep === 1) {
      setProcessandoAlteracaoRespostas(true)
      try {
        await exameRealizadoService.alterarRespostas(
          { respostasQuesitos },
          setProcessandoAlteracaoRespostas
        )
        await exameRealizadoService.gerarDocumento(
          params.idExameRealizado,
          setProcessandoAlteracaoRespostas
        )
        router.history.push({
          pathname: `/casos/caso/solicitacao/exameSolicitado/editorExameRealizado/${params.idExameRealizado}`,
          state: { IgnoneUploadImagem: true },
        })
      } catch (error) {
        console.error('Error finalising exam answers:', error)
      } finally {
        setProcessandoAlteracaoRespostas(false)
      }
    } else {
      setActiveStep((prevStep) => prevStep + 1)
    }
  }, [activeStep, params.idExameRealizado, respostasQuesitos, router.history]) // Excluded service dependency to prevent loops

  useEffect(() => {
    fetchExameRealizado()
  }, [fetchExameRealizado])

  return {
    params,
    exameRealizado,
    activeStep,
    respostasQuesitos,
    setRespostasQuesitos,
    processandoAlteracaoRespostas,
    handleEtapaAnterior,
    handleProximaEtapa,
  }
}
